import Contracts from '@/components/contracts/Contracts'
import ContractDetail from '@/components/contracts/ContractDetail'
import ContractCreate from '@/components/contracts/ContractCreate'
import ContractUpdate from '@/components/contracts/ContractUpdate'
import BeneficiaryCreate from '@/components/contracts/beneficiaries/BeneficiaryCreate'
import BeneficiaryUpdate from '@/components/contracts/beneficiaries/BeneficiaryUpdate'

const contractsRoutes = [
  { path: '/contracts', name: 'contracts', component: Contracts },
  { path: '/contract/create', name: 'contract_create', component: ContractCreate },
  { path: '/contract/update/:id', name: 'contract_update', component: ContractUpdate },
  { path: '/contract/:id', name: 'contract', component: ContractDetail },
  { path: '/contract/:id/beneficiary/create', name: 'beneficiary_create', component: BeneficiaryCreate },
  { path: '/:type/:contract_id/beneficiary/update/:id', name: 'beneficiary_update', component: BeneficiaryUpdate }
]

export default contractsRoutes



// WEBPACK FOOTER //
// ./src/router/contracts_routes.js